import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { colsComponent } from "../../app/data/adminCatalog";
import TableAppComponent from "./TableAppComponent";
import { cleanCatalogConcernByGroupVision, startLoadingCatalogsByGroupVision } from "../../app/actions/catalogActions";
import { useTranslation } from "react-i18next";

const ListGroupComponent = ({ groupVisionSelected, setGroupVisionSelected }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { listGroups } = useSelector((state) => state.catalog);
  
  // Estado para el filtro local
  const [filterText, setFilterText] = useState("");
  const [rowIsActive, setRowIsActive] = useState(null);

  // Lógica de filtrado local
  /*const filteredData = useMemo(() => {
    return listGroups.filter(item => 
      item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.id?.toString().includes(filterText)
    );
  }, [listGroups, filterText]);*/

  const filteredData = useMemo(() => {
  // 1. Validamos que listGroups exista y sea una lista
  if (!Array.isArray(listGroups)) {
    return [];
  }

  return listGroups.filter(item => 
    item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
    item.id?.toString().includes(filterText)
  );
}, [listGroups, filterText]);

  const onSelectRow = (row) => {
    //console.log("AAA, click in onSelectRow");
    dispatch(cleanCatalogConcernByGroupVision());
    setRowIsActive(row.id);
    //console.log("AAA, onSelectRow, row", row);
    setGroupVisionSelected(row);
    dispatch(startLoadingCatalogsByGroupVision(row.id));
  };

  return (
    <div className="list-group-container">
      {/* Buscador Sencillo Estilo Panel Derecho */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder={t("Buscar catálogo...")}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <div className="mt-2 mb-1" style={{ fontSize: '14px', fontWeight: 'bold', color: '#666' }}>
          {t("Disponibles")} ({filteredData.length})
        </div>
      </div>

      <TableAppComponent 
        cols={colsComponent} 
        data={filteredData} 
        onSelectRow={onSelectRow} 
        rowIsActive={rowIsActive}
      />
    </div>
  );
};

export default ListGroupComponent;
